var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.can_createAuction)?_c('sButton',{attrs:{"data-qa":"btn-create-auction","loading":_vm.loading},on:{"click":_vm.createAuction}},[_vm._v(" "+_vm._s(_vm.$t(`Tenders.CreateAuction`))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }